import script from "./assets-category-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./assets-category-modal.vue?vue&type=script&setup=true&lang=js"

import "./assets-category-modal.vue?vue&type=style&index=0&id=239132e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239132e6"]])

export default __exports__